import React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    Divider,
    IconButton,
    TextField,
    Box
} from "@mui/material";
import SoftButton from "../../components/SoftButton";
import PropTypes from "prop-types";
import { IoClose } from "react-icons/io5";

const SelectOCRTypeConfirmationDialog = ({ open, title, onClose, onConfirm, ocrType, handleOcrTypeChange, ocrTypeError }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle
                id="form-dialog-title"
                sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
                <Typography variant="h5" component="span" fontWeight="bold">
                    {title}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ position: "absolute", right: 8, top: 8 }}
                >
                    <IoClose size={20} />
                </IconButton>
            </DialogTitle>

            <Divider />
            <DialogContent>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Typography variant="body2" sx={{ fontWeight: 500, color: "#374151", fontSize: "0.875rem" }}>
                        Please enter the OCR type. It must be one of the following values: 
                            (default, light, agentic)
                    </Typography>

                    <TextField
                        fullWidth
                        value={ocrType}
                        onChange={(e) => handleOcrTypeChange(e.target.value)}
                        size="medium"
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                backgroundColor: "white",
                                "& fieldset": {
                                    borderColor: "#d1d5db",
                                },
                                "&:hover fieldset": {
                                    borderColor: "#9ca3af",
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: "#3b82f6",
                                    borderWidth: "2px",
                                },
                                "& input": {
                                    padding: "8px 12px",
                                    fontSize: "0.875rem",
                                    "&::placeholder": {
                                        color: "#9ca3af",
                                        opacity: 1,
                                    },
                                },
                            },
                        }}
                    />
                    {ocrTypeError && <p className="error-text">Invalid OCR Type</p>}
                </Box>
            </DialogContent>
            <Divider />
            <DialogActions>
                <SoftButton onClick={onClose} variant="contained" color="light">
                    Cancel
                </SoftButton>
                <SoftButton onClick={onConfirm} variant="contained" color="primary">
                    Confirm
                </SoftButton>
            </DialogActions>
        </Dialog>
    );
};

SelectOCRTypeConfirmationDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    ocrTypeError: PropTypes.bool.isRequired,
    title: PropTypes.string,
    ocrType: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    handleOcrTypeChange: PropTypes.func.isRequired,
};

export default SelectOCRTypeConfirmationDialog;
